import ContractsMileageCargoCompanyDetailsRequest from "../../../../api/raily/contracts/mileage/cargo-company-details/contracts-mileage-cargo-company-details.request";
import ContractsMileageCargoCompanyDetailsParams from "./contracts-mileage-cargo-company-details-params";

const create = (
  params: ContractsMileageCargoCompanyDetailsParams,
): ContractsMileageCargoCompanyDetailsRequest => {
  return {
    cargoCompanyUuid: params.cargoCompanyUuid,
    validAt: params.validAt,
  };
};

const contractsMileageCargoCompanyDetailsParamsFactory = {
  create,
};

export default contractsMileageCargoCompanyDetailsParamsFactory;
